<template lang="pug">
p.p-doc(
  :inner-html.prop="final_text | remove_intro_chars | applyLinks(linksData)"
  v-show="is_visible"
  :class="{'bg-secondary': highlight_background_visible}"
)
</template>

<script>
import filters from 'common/filters.js'
import { mapMutations } from 'vuex'

export default {
  props: {
    text: { type: String, default: '' },
    cleaned_tokens: { type: Array, default: () => [] },
    show_all: { type: Boolean, default: false },
    highlight_add_buttons: { type: Boolean, default: false },
    highlight_background: { type: Boolean, default: false },
    linksData: { type: Object, default: () => { return {} } }
  },
  data() {
    return {
      is_visible: true,
      replaced_text: this.processReplacement(this.cleaned_tokens)
    }
  },
  filters: {
    highlight: filters.highlight,
    remove_intro_chars: filters.remove_intro_chars,
    applyLinks: filters.applyLinks
  },
  computed: {
    final_text() {
      return this.cleaned_tokens.length > 0 && !this.show_all && this.text == this.replaced_text ? '...' : this.replaced_text
    },
    highlight_background_visible() {
      return this.cleaned_tokens.length > 0 && this.highlight_background && this.text != this.replaced_text
    }
  },
  methods: {
    toggle_visibility() {
      this.is_visible = !this.is_visible
    },
    processReplacement(cleaned_tokens) {
      return this.$options.filters.highlight(
        this.text, cleaned_tokens, true, this.highlight_add_buttons
      )
    },
    manageTextReplacement(tokens) {
      this.replaced_text = this.processReplacement(tokens)
      if (this.highlight_add_buttons) {
        this.increaseParagraphsProcessed()
      }
    },
    ...mapMutations('document', [
      'increaseParagraphsProcessed'
    ])
  },
  mounted() {
    if (this.cleaned_tokens.length > 0) {
      this.manageTextReplacement(this.cleaned_tokens)
    }
  },
  watch: {
    cleaned_tokens(value) {
      this.manageTextReplacement(value)
    }
  },
}
</script>
